<template>
  <!-- <modal
    :name="modalName"
    adaptive reset
    draggable=".window-header"
    @closed="closed"
    overlayTransition=""
    width="900"
    height="auto" scrollable
    :clickToClose=false
  > -->
  <!-- height="470" -->
  <!-- https://github.com/euvl/vue-js-modal -->
<div>
  <!-- 증표내역 수정 : 증표사용 및 내역수정에서 호출된다. -->

    <c회원선택2 ref="selectCust" @select="selectCust" @no_first_result="$refs.search_membnm.select()" :memblist=selectCustList  />

    <h5 class="pop_tit window-header"><!-- 타이틀바 -->
      증표 상세 <small>( 상태: {{ sitem.statclsfnm }} )</small>

      <span class="right" style="margin-right: 50px;">
        <span v-if="this.print_mode && T.isEmpty(sitem.prtno)">
            <!-- N = 표 보이기 / Y = 레포트 보이기 -->
            <a class="btn mini" @click="print_mode = false">수정하기</a>
            <a class="btn mini" @click="doPrintCall()">인쇄하기</a>
        </span>
      </span>
    </h5>
    <span class="pop_close d2" @click="doClose()"></span><!-- 닫기 -->

    <!--  증표 사용 등록/수정 폼 -->
    <div class="popup_wrap2"
      style="padding:10px; box-sizing: border-box;"
      v-if="this.print_mode == false"><!-- 인쇄모드가 아닐경우에만 수정폼을 보여준다 -->
      <p v-if="isOtherOffice" class="mb5 noprint">* 증표의 명의 소속과 현재 회원의 소속이 일치하지 않아 <b class="red02">수정할 수 없습니다.</b></p>
      <p v-else class="mb5 noprint"><b class="red02">* 빨간색 항목은 필수 입력</b>  사항입니다 .</p>

      <div id="printMe"
      style="overflow-y: scroll;"
      :style="{height: Math.min(840, windowHeight-185) + 'px'}"
      >
      <table class="tbl01 view01">
        <!-- <tr>
          <th class="th_gray gubun">구분</th>
          <th class="th_gray cont">내용</th>
          <th class="th_gray gubun">구분</th>
          <th class="th_gray cont">내용</th>
        </tr> -->
        <tr>
          <th>증표번호</th>
          <td>
            {{ sitem.rcptno | rcptno }}<img v-if="sitem.onlineyn == 'Y'" src="/images/common/icon_online2.png" title="온라인증표" class="icon_online" @click="popupViainfo(sitem)">
            <span style="color: #9F9F9F; margin-left: 10px;">(수정번호 : {{ sitem.updatecnt }})</span>
            <span><b class="red02">{{sitem.onlineyn == 'N' ? ' 이 증표는 전자증표가 아닌 종이증표입니다. 실물이 없으시면 사용이 불가능합니다.' : ''}}</b></span>
          </td>
        </tr>
        <tr>
          <th>증표 종류</th>
          <!-- <td>{{ sitem.caseclsfnm }}</td> -->
          <td>
            {{ sitem.org_caseclsfnm  }}
            <!-- 면제사건종류가 "기타"인 경우 기타 TEXT 보이기 -->
            <template v-if="sitem.freeclsf == 'B10960'"> / {{ sitem.freeclsf_etc }}</template>
          </td>
        </tr>
        <tr>
          <th>구입일자</th> <td>{{ sitem.sellpayokdt || sitem.selldt | moment('YYYY.MM.DD') }}</td>
        </tr>
        <tr>
          <th>금액</th>
          <td :id="`id_chcase_${sitem.ch_caseyn}`"
             :class="{ 'blue01 b' : sitem.ch_caseyn == 'Y' }">{{ sitem.viafee | comma }}원
            <div class="toggleInfo">
                <p class="tit">오사용 증표 정정 신청한 증표임 </p>
                <div class="cont">
                  <ol>
                    <li>신청일 : {{ sitem.viastatdt | moment('YYYY.MM.DD.') }}</li>
                    <li>변경 전 경유 증표 : {{ sitem.org_caseclsf }}, {{ sitem.org_viafee | comma }}원</li>
                    <li>변경 후 경유 증표 : {{ sitem.to_caseclsf }},  {{ sitem.to_viafee  | comma }}원</li>
                    <li>정정사유 : {{ sitem.rchcase_reasonclsfnm }}</li>
                  </ol>
                </div>
              </div>

          </td>
        </tr>
        <tr>
          <th class="req">수임일자</th>
          <td >
              <!-- 수임일자 수정 가능 여부
                *       수정 가능        |    수정 불가
                * 사용 증표 & 오프라인   | 사용 증표 & ( 온라인  | 면제(소속변경) )
                * 미사용 증표
                * canRedEdit 사용 증표면 false
                *           미사용이면 true
                * isOffline 오프라인이면 true
                          온라인이면   fasle

                *** 또 변경됨. 무조건 canRedEdit 에 따름
              -->
                <!-- <i-input-date v-if="canRedEdit || isOffline" v-model="sitem.cntchargdt" input-class="" title="수임일자" /> -->

                <!-- <i-input-date v-if="canRedEdit || (sitem.caseclsf == 'B10400' && sitem.freeclsf == 'B10910')"  소속변경 면제일때 왜 수임일자 수정이 가능하지 ?? 라는 질문이 올라와서 일딴 막아둠. -->
                <i-input-date v-if="canRedEdit"
                  :value="sitem.cntchargdt" @input="onChange_cntchargdt" input-class="" title="수임일자" />
                <span v-else>{{ sitem.cntchargdt }}</span>
          </td>
         </tr>
         <tr>
          <th class="req">사건유형</th>
          <td>
            <select v-model="sitem.casetype" v-if="canRedEdit">
              <option value="" selected="selected">선택</option>
              <option v-for="item in code[sitem.caseclsf]" :value="item.value" :key="item.value">{{item.text}}</option>
            </select>
            <span v-else>{{ sitem.casetypenm }}</span>
          </td>
        </tr>
        <tr>
          <th class="req">관할기관</th>
          <td :colspan="showSimGeup ? 1 : 3" v-tooltip.left="sitem.isttoutplac__change >= 1 ? '1회 수정하여 더이상 수정할 수 없습니다.' : '1회이상 수정 불가능합니다.'">
            <template v-if="sitem.isttoutplac__change >= 1 || allReadOnly">
              <span>{{ sitem.isttoutplac }}</span>
            </template>
            <template v-else>
              <!-- 관할기간 선택 -->
              <select v-model="sitem.isttoutplac" @change="onChange_isttoutplac">
                <option value="" selected="selected">선택</option>
                <option v-for="item in code.BG0000"
                        :value="item.text"
                        :key="item.value">{{item.text}}</option>
                <option value="etc">직접 입력</option>
              </select>
              <!-- 관할기간 기타시 직접 입력 -->
              <template v-if="sitem.isttoutplac == 'etc'">
                <!-- 심급을 보여줄땐 br 을 주어서 관할기관 직접입력을 보여준다.  -->
                <div v-if="showSimGeup" style="margin-top: -7px;"><br style="margin: 0"/></div>
                <input :class="{ml10: !showSimGeup}" v-model="sitem.isttoutplac_etc" type="text" ref="isttoutplac_etc"/>
              </template>
            </template>

          </td>
        </tr>
        <tr v-if="showSimGeup">
          <th class="req">심급</th>
          <td>
            <div v-if="canRedEdit">
              <select v-model="sitem.simgeup">
                <option value="" selected="selected">선택</option>
                <option v-for="item in simGeupList"
                        :value="item.value"
                        :key="item.value">{{item.text}}</option>
              </select>
              <input v-if="sitem.simgeup == 'B11109' || sitem.simgeup == 'B11204'" type="text" v-model="sitem.simgeup_etc"/>
            </div>
            <div v-else>
              <span v-for="item in simGeupList.filter(e=> e.value == sitem.simgeup)" :key="item.value">{{item.text}}</span>
              <span v-if="sitem.simgeup == 'B11109' || sitem.simgeup == 'B11204'"> ( {{ sitem.simgeup_etc }} )</span>
            </div>
          </td>
        </tr>
        <tr>
          <th class="req">사건명</th>
          <td v-tooltip="sitem.casenm__change >= 1 ? '1회 수정하여 더이상 수정할 수 없습니다.' : '1회이상 수정 불가능합니다.'">
            <template v-if="sitem.casenm__change >= 1 || allReadOnly">
              {{ sitem.casenm }}
            </template>
            <template v-else>
              <input v-model="sitem.casenm" :disabled="casenmDisable" type="text" class="m_50p left"/>
              <label><input v-model="sitem.casenmyn"
                      @change="casenmYN()"
                      true-value="Y"
                      false-value="N"
                      type="checkbox" class="ml10" /> 미정
              </label>
            </template>

            <!-- <div style=" margin: 5px 0 0 0; padding: 0;"> -->
            <input type="checkbox"
                   v-model="sitem.linkyn"
                   id="linkyn"
                   true-value="Y"
                   false-value="N"
                   class="ml10"
                   :disabled="allReadOnly"/>
            <label for="linkyn">연결사건 </label>

              <span id="id_rel" class="noprint">
                <em class="icon_info">i</em>
                <div class="toggleInfo">
                  <p class="tit">연결사건이란? </p>
                  <div class="cont">
                    <p class="brown01 mt0 mb20">본안사건과 신청사건을 수임하여 소송수행 중에 발생되는 부수적･파생적인 사건으로서 각 소송위임장마다 경유증표를 부착하되 경유사건 수를 1건으로 처리하는 사건을 말합니다.</p>
                    <ol>
                      <li>가압류이의신청과 제소명령신청을 동시에 하는 경우</li>
                      <li>가압류집행취소신청(가압류이의신청사건을 수임한 경우)</li>
                      <li>가집행선고 실효로 인한 원상회복(또는 손해배상)신청</li>
                      <li>관할법원지정신청</li>
                      <li>구속적부심사청구사건, 영장실질심사청구사건을 본안으로 경유하였으나, 당해 사건이 기각되어 변호인선임서를 다시 제출하는 경우</li>
                      <li>권리승계인의 소송참가신청</li>
                      <li>다수의 일방당사자 중 그 일부만이 상소하였다가 상대방 당사자가 전부 상소를 제기하여 나머지 일방당사자의 위임장을 제출하는 경우</li>
                      <li>당사자가 여러 명인 사건을 수임하여 각각의 위임장을 제출하는 경우(형사사건은 제외)</li>
                      <li>보조참가에 대한 이의신청</li>
                      <li>소송구조취소신청(소송구조사건 수임한 경우)</li>
                      <li>소송수계신청, 소송물가액결정신청</li>
                      <li>소송위임장을 관할법원이 아닌 다른 법원에 제출하여 다시 관할법원에 제출하는 경우</li>
                      <li>소송이송신청</li>
                      <li>소송참가승계허가신청(채권양도 등)</li>
                      <li>위임인의 사건이 병합되었을 경우</li>
                      <li>정식재판청구와 정식재판청구권회복청구를 동시에 하는 경우</li>
                      <li>조정사건이송신청</li>
                      <li>집행문부여(집행)에 관한 이의신청에 기한 잠정처분 신청</li>
                      <li>착오로 경유회비 면제사건에 경유증표를 사용한 경우</li>
                      <li>착오로 소송위임장을 이중으로 접수하거나, 분실하여 다시 제출하는 경우</li>
                      <li>채권가압류집행취소신청(채권가압류취소신청사건을 수임한 경우)</li>
                      <li>추가재판신청(민소 212조)</li>
                      <li>피신청인경정신청</li>
                    </ol>
                  </div>
                </div>
              </span>

            <!-- </div> -->
          </td>
        </tr>
        <tr>
          <th class="req">위임인</th>
          <td v-tooltip="sitem.client__change >= 1 ? '1회 수정하여 더이상 수정할 수 없습니다.' : '1회이상 수정 불가능합니다.'">
            <template v-if="canRedEdit">

              <!-- 위임인 선택 신동호 -->

              <select v-model="sitem.clientclsf">
                <option v-for="item in code.B50000"
                        :value="item.text"
                        :key="item.value">{{item.text}}</option>
                <option value="etc">직접 입력</option>
              </select>

              <!-- 위임인 직접입력 -->

              <template v-if="sitem.clientclsf == 'etc'">

                <input v-model="sitem.clientclsf_etc" type="text" class="ml10" style="width: 120px;" placeholder="위임인 구분"/>
                <input v-model="sitem.client" type="text" :class="{ml10: sitem.clientclsf != 'etc'}" class="input_name" placeholder="위임인 성함 입력"/>

                <div style="margin-top: -7px;"><br style="margin: 0"/></div>

              </template>

              <template v-else>

               <input v-model="sitem.client" type="text" :class="{ml10: sitem.clientclsf != 'etc'}" class="input_name" placeholder="위임인 성함 입력"/>

              </template>

            </template>

  <template v-if="sitem.statclsf == 'BC0200'">
            <!-- 위임인1 (원고 피고 상대방) -->

              <template v-if="sitem.clientclsf__change >= 1 || allReadOnly">
              {{ sitem.clientclsf }}
            </template>

            <template v-else>
              <input v-model="sitem.clientclsf" :disabled="clientDisable" type="text" class="m_20p left"/> <!-- 신동호2 -->

            </template>

            <!-- 위임인2 (성함) -->

             <template v-if="sitem.client__change >= 1 || allReadOnly">
              {{ sitem.client }}
            </template>

             <template v-else>

              <input v-model="sitem.client" :disabled="clientDisable" type="text" class="m_50p left"/>

            </template>
   </template>

          <span id="id_client" class="noprint">
              <em class="icon_info" >i </em>
                <div class="toggleInfo">
                  <p class="tit">위임인 </p>
                  <div class="cont">
                      사건 수임을 의뢰한 당사자 명칭(원고, 피고)과 이름을입력하여 주십시오
                      <br/> 예) 원고: 홍길동, 고소인 : 홍기순
                  </div>
                </div>

            </span>

          </td>
         </tr>
         <tr>
          <!-- [사건유형] = 형사 인 경우 : [상대방]  입력 x --- 다시 넣어달라고 함 -->
          <!-- <template v-if="sitem.casetype !='B10102'"> -->
            <th class="req">상대방</th>

            <td v-tooltip="sitem.otherside__change >= 1 ? '1회 수정하여 더이상 수정할 수 없습니다.' : '1회이상 수정 불가능합니다.'" >

            <template v-if="sitem.otherside__change >= 1 || allReadOnly">
            {{ sitem.otherside }}
            </template>

              <template v-else>
              <input v-model="sitem.otherside" :disabled="clientDisable" type="text" class="m_50p left"/>

              <!-- [없음] 체크박스 조건
                show                       | hidden
                사용안한 증표(canRedEdit)    | 사용한증표 이면서 기존에 [없음]에 체크한 경우
                able                       | disable
                사용안한증표               | 사용한 증표
               -->
              <label v-if="canRedEdit || !canRedEdit && sitem.othersideyn == 'Y'">
                <input v-model="sitem.othersideyn"
                       @change="othersideYN()"
                       :disabled="!canRedEdit"
                       true-value="Y"
                       false-value="N"
                       type="checkbox" class="ml10" /> 없음
              </label>
               </template>
            </td>
          <!-- </template>
          <template v-else><th></th><td>&nbsp;</td></template> -->
        </tr>
        <tr>
          <th>사건번호</th>
          <td v-tooltip="sitem.caseno__change >= 3 ? '3회 수정하여 더이상 수정할 수 없습니다.' : '3회이상 수정 불가능합니다.'">
            <template v-if="sitem.caseno__change >= 3 || allReadOnly">
              {{ sitem.caseno }}
            </template>
            <template v-else>
              <input type="text" v-model="sitem.caseno" :disabled="casenoDisable" class="m_50p"/>
              <label><input v-model="sitem.casenoyn"
                            @change="casenoYN()"
                            true-value="Y"
                            false-value="N"
                            type="checkbox" class="ml10" /> 미정
              </label>
              <span v-if="sitem.caseno__change">
                ({{ sitem.caseno__change }}회 수정)
              </span>
            </template>
          </td>
        </tr>
        <tr>
        <!--           <th :class="{ 'req' : isOffline }">사용일자</th>
          <td>
            <i-input-date v-if="isOffline" v-model="sitem.viadt" input-class="" title="경유일자" />
            <span v-else>{{ sitem.viadt }}</span>
            <small v-if="!isOffline" class="comment" style="color: #8E8E8E;"> (온라인 증표는 인쇄시에 자동 설정, 오프라인 증표는 저장 후 24시간 이내에 수정가능)</small>
          </td> -->
          <th>경유일자</th>
          <td>
            <span v-if="sitem.viadt">{{ sitem.viadt }}</span>
            <!-- <small v-else class="comment" style="color: #8E8E8E;"> (전자증표는 인쇄시에, 오프라인 증표는 저장시에 사용일이 설정됩니다.)</small> -->
          </td>
        </tr>
        <tr v-if="sitem.statclsf == 'BC0200' || sitem.statclsf == 'CH_OFFICE'"><!-- 사용이거나 소속변경완료인 경우 -->
          <th>전체 사임/취하</th>
          <td >
            <template v-if="dbitem.viacancelclsf"><!-- 디비에서 조회한 값에 사임취하가 있다면 그것만 보여준다. -->
              전체 {{ T.code(code.B40000, dbitem.viacancelclsf) }}
              ( {{ T.code(code.B40000, dbitem.viacancelclsf) }}일 = {{ dbitem.viacanceldt | moment('YYYY.MM.DD.') }} )
            </template>
            <template v-else>
              <span v-for="code in _.omitBy(code.B40000, {value: 'B40100'})" :key="code.value"> <!-- B40200 사임 B40300 취하 B40100 공란  -->
              <label style="padding-right: 10px;">
              <input
                type="radio"
                :name="'viacancelclsf'"
                :value="code.value"
                @click="e=>onClickCancelCslf(e, sitem, 'viacancelclsf', '')"
                :id="'viacancelclsf'"
                :checked="sitem.viacancelclsf == code.value"
                class="sch_input"
                :disabled="(sitem.statclsf != 'BC0200' && sitem.statclsf != 'CH_OFFICE') || allReadOnly"
                v-tooltip="'한번 사임/취하를 하시고 저장을 하시면 이후에 사임/취하 여부는 수정하실 수 없습니다.'"
              /> {{ code.text }}</label>
              </span>
              <span class="mt10" v-show="sitem.viacancelclsf && sitem.viacancelclsf != 'B40100'">
                <i-input-date
                input-class=""
                title="사임/취하일자"
                v-model="sitem.viacanceldt"
                :disabled="(sitem.statclsf != 'BC0200' && sitem.statclsf != 'CH_OFFICE') || allReadOnly"
                @input="checkViacanceldt"
              />
              </span>
              <span style="color: red; padding-left: 10px; ">{{ error_viacanceldt }}</span>
            </template>
          </td>
        </tr>
        <tr>
          <th class="req">담당변호사</th>

          <td>
            <template v-if="showChargerAddBtn()">
               <div class="lawer_sch">

                  <input type="text" ref="search_membnm" v-model="sitem.search_membnm" @keydown.enter="openCustPop" class="input_name"/>
                  <i-btn @click="openCustPop" class="btn xs gray01">회원추가</i-btn>
               </div>
            </template>
            <div class="damdang_wrap">
              <!-- div 팝업 :: 담당 변호사 검색 결과-->
              <table class="tbl01 list01">
                <tr>
                  <th>등록번호</th>
                  <th>회원명</th>
                  <template v-if="sitem.statclsf == 'BC0200' || sitem.statclsf == 'CH_OFFICE'"><!-- 사용이거나 소속변경완료인 경우 -->
                    <th>변호사별 사임여부</th>
                    <th>담당변호사 추가지정일</th>
                    <th>등록일</th>
                  </template>
                  <th width="40px;">구분</th>
                </tr>

                <tr v-for="(item, i) in selectCustList" :key="i">
                  <td>{{ item.chrgmembno }} </td>
                  <td>
                    {{ item.membnm }}
                    <span id="id_client">

                    <em v-if="item.membno == sitem.freemembno" class="icon_info noprint" >i</em>
                      <div class="toggleInfo">
                        <p class="tit">건수차감 변호사 </p>
                        <div class="cont">
                            무료변론 건수차감으로 지정된 변호사 입니다.
                        </div>
                      </div>

                    </span>
                  </td>

                  <!-- 사임취하 처리 : 사용(BC0200)이거나 소속변경완료(CH_OFFICE)인 경우 : 수정 가능 -->
                  <template v-if="sitem.statclsf == 'BC0200' || sitem.statclsf == 'CH_OFFICE'">
                    <td style="padding: 5px 0;">
                      <!-- 디비에서 조회한 값에 전체사임취하가 있거나, 개별적으라도 사임/취하가 있다면 수정불가하고 그것만 보여준다. -->
                      <template v-if="dbitem.viacancelclsf || (!_.isEmpty(item.dbcancelclsf) && item.dbcancelclsf != 'B40100')">
                        <!-- 디비에서 조회한 값에 사임취하가 있다면 그것만 보여준다. -->
                        <template v-if="!_.isEmpty(item.dbcancelclsf) && item.dbcancelclsf != 'B40100'"> <!-- 값이 있고 공란(B40100)이 아닐경우 에만 보여준다. -->
                            변호사별 {{ T.code(code.B40000, item.dbcancelclsf) }} ( {{ item.dbcanceldt | moment('YYYY.MM.DD.') }} )
                        </template>
                        <template v-else>
                          ( 전체 {{ T.code(code.B40000, dbitem.viacancelclsf) }} )
                        </template>
                      </template>
                      <template v-else>
                        <!-- <span v-for="code in _.omitBy(code.B40000, {value: 'B40100'})" :key="code.value"> -->
                        <span v-for="code in _.pickBy(code.B40000, {value: 'B40200'})" :key="code.value"> <!-- B40100 공란 B40200 사임 B40300 취하  -->
                          <input
                            type="radio"
                            :name="'cancelclsf_'+i"
                            :value="code.value"
                            @click="e=>onClickCancelCslf(e, item, 'cancelclsf', 'B40100')"
                            :id="`${ code.value }_${ item.membno }`"
                            :checked="item.cancelclsf == code.value"
                            class="sch_input"
                            :disabled="(sitem.statclsf != 'BC0200' && sitem.statclsf != 'CH_OFFICE') || !_.isEmpty(sitem.viacancelclsf) || allReadOnly"
                            v-tooltip="'한번 사임을 하시고 저장을 하시면 이후에 사임 여부는 수정하실 수 없습니다.'"
                          />
                          <label :for="`${ code.value }_${item.membno}`">{{ code.text }}</label>
                        </span>
                        <span class="mt10" v-show="item.cancelclsf != 'B40100'">
                          <i-input-date
                            input-class=""
                            title="사임/취하일자"
                            v-model="item.canceldt"
                            @input="setLastCancelDT"
                            :disabled="(sitem.statclsf != 'BC0200' && sitem.statclsf != 'CH_OFFICE') || allReadOnly"
                          />
                        </span>
                      </template>
                    </td>
                    <td style="padding: 0">
                      <template v-if="item.addyn == 'Y' || !orgViaMembNos.includes(item.chrgmembno.trim())">
                        <i-input-date
                          input-class=""
                          title="담당변호사 추가지정일"
                          v-model="item.adddt"
                          :disabled="allReadOnly"
                        />
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td><!-- 등록일 -->
                    <td style="padding: 0">{{ item.incmgdt | moment('YYYY.MM.DD') }}</td><!-- 등록일 -->
                  </template>


                  <td>
                    <span
                      v-if="showChargerDeleteBtn(item)"
                      @click="delCust(item)"
                      class="btn td_xs org01 outline">삭제</span>
                  </td>
                </tr>
              </table>
              <!-- // div 팝업 :: 담당 변호사 검색 결과-->
              <!-- 개인 변호사인 경우 : 아래 문구 표시 x -->
              <div class="mt10 red01">
                <template v-if="$store.state.session.user.type == 'self' || $store.state.session.user.officeclsf == 'J' || $store.state.session.user.officeclsf == 'D'">
                  ※ 실제 사건을 담당한 변호사를 모두 입력해 주시기 바랍니다.
                </template>
                <template v-else>
                  ※ 변호사법 제50조(업무집행방법)에 의거, 실제 담당한 변호사를 모두 입력해야 하며, <br/>&nbsp;&nbsp;&nbsp;담당변호사 입력 시 반드시 구성원 변호사를 포함해야 합니다.
                </template>
              </div>

              <!-- 소속이 개인 변호가사 아닌 경우 분사무소 멤버 추가 가능 -->
              <template v-if="this.$store.state.session.user.officeclsf != 'P'" >
                <div class="lawer_sch" style="margin-bottom:10px; margin-top:10px;">
                  타회 소속 분사무소 담당변호사 추가:
                  <input type="text" v-model="sitem.submemb" @keydown.enter="addsubmembers(sitem.submemb)" class="input_name"/>
                  <i-btn @click="addsubmembers(sitem.submemb)" class="btn xs gray01">회원추가</i-btn>
                </div>
              </template>

              <div v-if="submembersList.length > 0">
                <table class="tbl01 list01">
                  <tr>
                    <th>회원명</th>
                    <th width="40px;">구분</th>
                  </tr>
                  <tr v-for="(item, i) in this.submembersList" :key="i">
                    <td>
                      {{ item }}
                      <span v-if="sitem.officeclsf == 'C'">[{{ sitem.officenm }}]</span>
                      <span v-else>({{ sitem.officenm }})</span>
                    </td>
                    <td>
                      <span
                        @click="delSubmem(item)"
                        class="btn td_xs org01 outline">삭제</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div><!-- //damdang_wrap-->
          </td>
        </tr>
        <tr>
          <th>비고</th>
          <td >
            <span v-if="allReadOnly">{{ sitem.remk }}</span>
            <input v-else type="text" v-model="sitem.remk" class="w100p" />
          </td>
        </tr>
        <tr>
          <th>수임액    </th> <td><span v-if="allReadOnly">{{ sitem.pay_con  | comma }}</span><i-input-money v-else type="text" v-model="sitem.pay_con" :maxlength="12" /></td>
       </tr>
       <tr>
          <th>성공보수금</th> <td><span v-if="allReadOnly">{{ sitem.pay_succ | comma }}</span><i-input-money v-else type="text" v-model="sitem.pay_succ" :maxlength="12" /></td>
        </tr>
      </table>
      <template v-if="sitem.prtdt">인쇄일 : {{ sitem.prtdt | moment('YYYY.M.D HH:mm') }}</template>
      <template v-if="sitem.prtdt2">, [2차] {{ sitem.prtdt2 | moment('YYYY.M.D HH:mm') }}</template>
      <template v-if="sitem.prtdt3">, [3차] {{ sitem.prtdt3 | moment('YYYY.M.D HH:mm') }}</template>
      </div> <!--//printMe -->
      <div class="btn_group" >
          <span v-if="sitem.statclsf == 'CH_REQ'">
            이 증표는
            <span style="font-weight :bold">{{ sitem.viastatmembset }}</span> 님이
            <span class="org01">{{ sitem.viastatclsfnm }}</span> 을(를) 신청하여 승인대기 중입니다.
          </span>

          <!-- 인쇄 : 신고신청 상태가 아닌 온라인 증표인 경우 -->
          <!-- <span v-if="sitem.statclsf == 'BC0500' sitem.onlineyn == 'Y' && sitem.statclsf != 'CH_REQ'"> -->
          <template v-if="sitem.statclsf == 'BC0200' || sitem.statclsf == 'CH_OFFICE'"> <!-- 상태: 사용 이거나 소속변경완료(CH_OFFICE) 인 경우-->
            <a class="btn center" v-if="sitem.onlineyn == 'Y' && this.print_mode == false && !isOtherOffice" @click="doPrintReport({showPRTNO: true})">인쇄</a>
            <a class="btn center black01" @click="saveItem({flag:'save'})" v-if="!allReadOnly">저장</a>
          </template>
          <template v-if="sitem.statclsf == 'BC0500' || sitem.statclsf == 'BC0100' && sitem.onlineyn == 'Y'"> <!-- 상태: 임시저장 -->
  <!--           <a class="btn center" v-if="this.print_mode == false" @click="doPrintReport({showPRTNO: false})">인쇄 미리보기</a> -->
            <!-- <a class="btn center black01" @click="saveItem({flag:'save_close'})">임시저장 + 닫기</a> -->
            <a class="btn center black01" @click="saveItem({flag:'tmpsave'})">임시저장</a>
          </template>
          <!-- 오프라인 증표 -->
          <template v-if="sitem.onlineyn == 'N' && (sitem.statclsf == 'BC0100' || sitem.statclsf == 'BC0500')">
            <a class="btn center black01" @click="saveItem({flag:'save_use'})">저장하기</a><!-- 저장하기 = 저장+사용 -->
          </template>

          <!-- 상태:사용 과 소속변경완료와 신청 이 아닌 경우 + 온라인증표 -->
          <template v-if="(sitem.statclsf != 'BC0200' && sitem.statclsf != 'CH_OFFICE' && sitem.statclsf != 'CH_REQ') && sitem.onlineyn == 'Y'">
            <a class="btn center black01" @click="saveItem({flag:'tmpsave_preview'})">임시저장 + 인쇄 미리보기</a>
          </template>
          <!-- 상태: 사용 + 오프라인 증표 + 사용이거나 소속변경완료인 경우-->
          <template v-if="sitem.onlineyn == 'N' && (sitem.statclsf == 'BC0200' || sitem.statclsf == 'CH_OFFICE')">
            <a class="btn center black01" @click="prePrint">인쇄</a>
          </template>
          <a class="btn center black01" @click="doClose()">닫기</a>
          <!-- <a class="btn center black01 outline btn_up" >위로</a> -->
          <!-- 상태: 미사용 + 오프라인 증표 -->
          <template v-if="sitem.onlineyn == 'N' && sitem.statclsf == 'BC0100'">

            <div class="right">
              <span id="id_paper" class="noprint">
                <em class="icon_info">i</em> 종이증표 분실처리란?
                <div class="toggleInfo">
                  <p class="tit">종이증표 미입력분 사용 처리란? </p>
                  <div class="cont">
                      <li class="b mb30 underline red01">종이증표를 분실하였거나 시간이 오래지나 사건내용을 알 수 없을 경우에 종이증표를 분실처리하는 기능입니다.</li>
                      <Br/>
                      <li class="b mb30 underline red01">종이증표 사건내용을 입력하실 경우에는 이 메뉴가 아니라 이전 화면으로 이동해서 사건내용 입력 후 저장하기 버튼을 누르시기 바랍니다.</li>
                      <br/>
                      <li>*유의사항</li>
                      <li>(1)미입력분 사용 처리한 증표는 미사용으로 다시 전환할 수 없습니다.</li>
                      <li>(2)미입력분 사용 처리한 증표는 [수임사건 내역 조회] > [수임사건 건수 조회] 및 [수임사건 상세 조회]에서 제외됩니다.</li>
                  </div>
                </div>
              </span>
              <a class="btn center org01" @click="doLost()">종이증표 분실처리</a>
            </div>

          </template>
      </div>
<!-- sitem.statclsf = {{ code.BC0000.find(v=>v.cd==sitem.statclsf) }} -->
    </div>
    <!-- <div v-else> -->
      <!-- <img :src="'/front/api/public/qrCode/' + sitem.qrcode" /> -->
    <!-- </div> -->
    <!-- print_mode = {{ print_mode }}
    report = {{ report }} -->
    <s-report :src="report" height="500" v-show="this.print_mode"/>
    <!-- https://acrobat.adobe.com/kr/ko/acrobat/pdf-reader.html -->
    <!-- <s-report :src="report" style="height: 0px; "/> -->
  <!-- </modal> -->
  </div>
</template>

<script>
let ui
import _config from '../plugins/config'
import Printd from 'printd'
import Adobe from '../plugins/adobe'
const isDebug = true && _config.IS_LOCAL
export default {
  test() {
    console.log("이게 되나 ?? = ", this);
  },
  components: {
    'c회원선택2' : require('@/components/c회원선택2.vue').default,
  },
  props : {
    menu         : {},
    param        : { type: Object },
    cb_save      : { type: Function },
    cb_via_use_ok: { type: Function },
  },
  data () {
    return {
      currentHeight: '300px',
      report : '', // 레포트 URL
      print_mode : false, // 레포트 출력모드여부 ( 이거 true가 되면 폼을 감춘다 )
      dbitem : {},
      sitem : {},
      sitem_init : {
        viaregdt       : '',
        viaseq         : 0,
        selldt         : '',
        viaplac        : '',
        viafee         : 0,
        caseclsf       : '',
        casetype       : '',
        sellyn         : 'N',  // 판매여부
        statclsf       : '',
        viacancelclsf  : '',
        viacanceldt    : '',
        cancelclsf     : '',
        canceldt       : '',
        simgeup        : '',
        simgeup_etc    : '',
        isttoutplac    : '',
        caseno         : '',
        casenm         : '',
        client         : '',
        otherside      : '',
        cntchargdt     : '',
        remk           : '',
        remk2          : '',
        rcptno         : '',
        rcptnoto       : '',
        agntpersnm     : '',
        agntpersprn    : '',
        viadt          : '',
        clientclsf     : '',
        etccase        : '',
        continuyn      : '',
        linkyn         : '',
        lostyn         : 'N',
        lawyernm       : '',
        freemembno     : '',
        sellregdt      : '',
        sellseq        : 0,
        selldtlsseq    : 0,
        attachid       : '', // 첨부파일 ID
      },
      code : {}, // 코드
      sCust : null,
      selectCustList : [],
      orgViaMembNos : [], // 원본 보관 ( 추가 여부 확인용 )
      loginInfo : {},
      modalName: "c증표사용수정_" + T.randomAZ(10),
      chkList : [],
      casenmDisable    : false, // 사건명 disabled 여부
      casenoDisable    : false, // 사건번호 disabled 여부
      othersideDisable : false, // 상대방 disabled 여부
      isUseVia : false, // 증표를 '사용(전자증표=인쇄, 종이증표=저장)' 했는지 여부 ( 사용한 경우 close 했을때 메뉴이동하게 한다.)
      error_viacanceldt : '',
      d : null,
      submembersList : [], // 분사무소 멤버들
      tmpcnt : 0, // 종이증표 관할기관 인쇄 시
      tmpisttoutplac : '' // 종이증표 관할기관 인쇄 시
    }
  },
  computed : {
    isOffline() {
      return this.sitem.onlineyn == 'N' // 오프라인이면 수임일 수정 가능
    },
    showSimGeup() { // 심급항목 : 증표종류가 신청(B10200), 등기(B10300)가 아닐 때만 보임
      return this.sitem.caseclsf != 'B10200' && this.sitem.caseclsf != 'B10300'
    },
    simGeupList() { // 사건유형이 형사(B10102) 또는 형사이외일 경우 심급 코드
      return ['B10102','B10402','B10802','B10902'].includes(this.sitem.casetype) ? this.code.B10102 : this.code.B11200
    },
    isOtherOffice() { // 증표의 office 와 현재 office 의 일치 여부
      /*
                   [ true ]                   |              [ false ]
      1) 소속변경완료 + OFFICE 정보 불일치    | 1) 소속변경완료 상태가 아닌 모든 증표
                                              | 2) 소속변경완료 + OFFICE 정보 일치
      */
      return this.sitem && this.sitem.statclsf == 'CH_OFFICE' && (this.sitem.officeclsf != this.$store.state.session.user.officeclsf || this.sitem.officeno.trim() != this.$store.state.session.user.officecno)
    },
    allReadOnly() { // 모든 항목 수정불가
    console.log("this.sitem.freeclsf =", this.sitem.freeclsf);

      if (this.sitem.statclsf == 'CH_REQ') return true // 신청 상태인 증표는 수정불가
      if (this.isOtherOffice) return true // 소속변경완료인 증표이면서 OFFICE가 불일치 : 수정 불가
      if (this.sitem && this.sitem.freeclsf == 'B10940') return true // 복대리인경우 모든 항목 수정 불가
      return false
    },
    canRedEdit() { // 빨간색 항목 수정 가능 여부
     //ui.alert(this.allReadOnly+" : " +this.sitem.onlineyn+" : "+this.sitem.statclsf);
      if (this.allReadOnly) return false
      if (this.sitem.onlineyn == 'Y') {
        return this.sitem.statclsf != 'BC0200' // 온라인 증표는 사용(BC0200) 안한 경우(미사용, 임시저장) 빨간색항목 수정 가능. 다른조건은 없음
      }

      if (this.sitem.statclsf != 'BC0200') return true // 오프라인 증표도 사용상태가 아니라면 수정 가능
      // TODO CHECK 이거 서버에서도 체크 필요
      //if (this.$moment().subtract(1, 'day').format("YYYYMMDD") <= this.sitem.viadt.replace(/-/g,"")) return true // 사용후 1일까진 수정 가능 - 20.01.02 직원들이 항의있다고 수정불가하게 해달라함.
      return false

    },
    prtCnt() { return (!T.isEmpty(this.sitem.prtdt ) ? 1 : 0)
                    + (!T.isEmpty(this.sitem.prtdt2) ? 1 : 0)
                    + (!T.isEmpty(this.sitem.prtdt3) ? 1 : 0)
    },
  },
  created() {
    ui = this.$ui;

    this.sitem = _.cloneDeep(this.sitem_init)
    this.selectCustList = [] // 변호사목록
    this.submembersList = [] // 분사무소 멤버 목록

    this.report           = '' // 레포트 초기화 (기존에 열려있던 레포트 닫기)
    this.print_mode       = false // 폼을 기본으로
    this.casenmDisable    = false, // 사건명 disabled
    this.casenoDisable    = false, // 사건번호 disabled
    this.othersideDisable = false, // 상대방 disabled

    // this.$modal.show(this.modalName);

    // 공통 코드 로드
    ui.codeLoad("B20000,B10000,B10100,B10200,B10300,B10400,B10500,B10600,B10700,B10800,B10900,BC0000,B40000,B60000,B10102,B11200,BG0000,B50000", code => {
      this.code = code

      this.loadData(_.pick(this.param, ['viaregdt', 'viaseq'])) // 1. 상세 데이터 조회
    });

  },

  mounted() {

    // const printOpt = Adobe.getAcrobatInfo()
    // console.log("********************************");
    // console.log(printOpt);
    // console.log(printOpt.acrobat);
    // console.log(printOpt.acrobatVersion);
    // console.log("********************************");


    // console.clear()
    // console.log("Printd = ", Printd);
    // console.log('when component is mounted!')

    this.$nextTick(() => {
      // window.addEventListener('resize', this.onResize);
      // this.currentHeight = window.innerHeight + "px"
      // this.height = "100px"
    })

    // const { Printd } = window.printd
    this.d = new Printd()
    const { contentWindow } = this.d.getIFrame()

    contentWindow.addEventListener(
      'beforeprint', () => console.log('before print event!')
    )
    contentWindow.addEventListener(
      'afterprint', () => console.log('after print event!')
    )


  },
  methods : {
    prePrint(){

      this.tmpcnt = this.sitem.isttoutplac__change // 관할기관 수정횟수를 잠시 간직

      if(this.sitem.isttoutplac  == 'etc'){ // 직접입력일 경우
        this.tmpisttoutplac = this.sitem.isttoutplac // 잠시 간직
        this.sitem.isttoutplac = this.sitem.isttoutplac_etc
      }

      this.sitem.isttoutplac__change = 2 // 수정횟수 1회가 넘어가면 셀렉트박스 대신 텍스트로 나오기 때문에 임시로 2로 설정 (텍스트로 만들기 위함)

      setTimeout(()=>this.testPrint(), 500) // 바로 넘어가면 셀렉트 박스로 나오기 때문에 딜레이 줌

    },
    testPrint() {
      // $htmlToPaper('printMe')
      this.d.print( this.$el, [`

#printMe { overflow-y: visible !important; height: 100% !important;}
.tbl01, .tbl06 { border-top:2px solid #666; width:100%;border-collapse: collapse; font-size:13px}
.tbl01.line { border:2px solid #aaa}

.tbl01 th, .tbl06 dt { border-bottom:1px solid #ddd; border-left:1px solid #ddd; padding:7px 12px; background-color: #f3f3f3; line-height: 1.8; vertical-align: top;}
.tbl01 td img { max-width: 100%;;} /*이미지 100% 넘어가는 over size 처리 */

.tbl01 thead th { text-align:center;}
.tbl01 td { padding:7px 2px; border-bottom:1px solid #ddd;border-left:1px solid #eee;line-height: 1.6; box-sizing: border-box; text-align: center;}
.tbl01.td_c td { text-align: center;}
.tbl01 th:first-child { min-width:40px;}
.tbl01 th:last-child, .tbl01 td:last-child { border-right:1px solid #eee;}

/*목록*/
.tbl01.list01 td{ text-align: left;}
.tbl01.list01 td:first-child{ text-align: center;}


.tbl01.view01 th:first-child { padding:7px 0 7px 18px; text-align: left; width:120px;}
.tbl01.view01 td { text-align: left;}
.tbl01.view01 td { padding: 7px 10px;/*padding: 15px 30px 이면 증표사용조회팝업*/text-align:left; }
.damdang_wrap { margin-top:10px;}
.damdang_wrap .tbl01 td, .damdang_wrap .tbl01 td, .damdang_wrap .tbl01 th:first-child { text-align:center; padding: 7px 0 !important ; }
.noprint, .toggleInfo, .btn { display:none;}
input[type="text"] { border:none;}


    `])

    if(!this.T.isEmpty(this.tmpisttoutplac)){ // 직접입력일 경우
      this.sitem.isttoutplac_etc = this.sitem.isttoutplac // 직접 입력한 값을 원상복구
      this.sitem.isttoutplac = 'etc' // 셀렉트 박스 직접입력으로 나오게 하기 위해 etc 세팅
    }
    this.sitem.isttoutplac__change = this.tmpcnt // 관할기관 수정 횟수 원상복구

    },

    // doClose() { this.$modal.hide(this.modalName); }, // 닫기버튼
    doClose() { this.$emit('close') }, // 닫기버튼
    reloadData() { this.loadData(_.pick(this.sitem, ['viaregdt', 'viaseq'])) }, // reload
    loadData({viaregdt, viaseq}) { // 증표 내용을 조회한다.

      isDebug && console.log("loadData("+ JSON.stringify(arguments[0])+")")

      // ------------------------------------------------------------------------------------
      // 1. 증표 상세 데이터 조회
      // ------------------------------------------------------------------------------------
      ui.httpGetDetail('/proc/N_VIAINFO_DTL_V03', { viaregdt, viaseq, menu : 'FRONT_EDIT' }, ret => {

        let tmp = ret.data.rs1[0]

        tmp.cntchargdt = tmp.cntchargdt && this.$moment(tmp.cntchargdt).format("YYYY-MM-DD")
        tmp.viadt      = tmp.viadt      && this.$moment(tmp.viadt).format("YYYY-MM-DD") // 사용일 있으면 YYYY-MM-DD 형식으로 출력

        // 사임/취하구분 없을 경우 공란(B40100) 기본 선택
        tmp.cancelclsf = tmp.cancelclsf || 'B40100'

        /*  canRedEdit에서 sitem이 비어있기 때문에 밑으로 옮김  */
        // if (!T.isEmpty(tmp.isttoutplac)) {
        //   // [관할기관] 코드에 해당하는 값이 없으면 [직접입력]으로 보임
        //   let check_inc = this.code.BG0000.filter(e => e.text == tmp.isttoutplac)

        //   if (check_inc.length == 0) { // isttoutplac의 값이 [관할기관] 코드에 일치 하는 것이 없다
        //     // if (tmp.statclsf != 'BC0200') { // 사용하지 않은 증표는 isttoutplac 값을 etc로 지정하여, select-box 에서 '기타'가 선택되게 한다.
        //     if (this.canRedEdit) { // 사용하지 않은 증표는 isttoutplac 값을 etc로 지정하여, select-box 에서 '기타'가 선택되게 한다.
        //       tmp.isttoutplac_etc = tmp.isttoutplac
        //       tmp.isttoutplac = 'etc'
        //     }
        //   }
        // }

        // if (!T.isEmpty(tmp.clientclsf)) {
        //   // [위임인 구분] 코드에 해당하는 값이 없으면 [직접입력]으로 보임
        //   let check_client = this.code.B50000.filter(e => e.text == tmp.clientclsf)

        //   if (check_client.length == 0) { // clientclsf의 값이 [위임인 구분] 코드에 일치 하는 것이 없다
        //     //if (tmp.statclsf != 'BC0200') { // 사용하지 않은 증표는 clientclsf 값을 etc로 지정하여, select-box 에서 '직접입력'이 선택되게 한다.
        //     if (this.canRedEdit) {
        //       tmp.clientclsf_etc = tmp.clientclsf
        //       tmp.clientclsf = 'etc'
        //     }
        //   }
        // }

        //-------------------------------------------------------------------------------------
        // 사건명(casenm) - 미정 , 사건번호(caseno) - 미정 , 상대방(otherside) - 없음 체크
        //-------------------------------------------------------------------------------------
        if (tmp.casenm == '-') {
          tmp.casenmyn = 'Y' // [미정]에 체크
          tmp.casenm = ''
          this.casenmDisable = true // 사건명 disabled를 true로 설정 신동호1
        }
        if (tmp.caseno == '-') {
          tmp.casenoyn = 'Y' // [미정]에 체크
          tmp.caseno = ''
          this.casenoDisable = true // 사건번호 disabled를 true로 설정
        }
        if (tmp.otherside == '-') {
          tmp.othersideyn = 'Y' // [없음]에 체크
          tmp.otherside = ''
          this.othersideDisable = true // 상대방 disabled를 true로 설정
        }

        tmp.viacanceldt = tmp.viacanceldt && this.$moment(tmp.viacanceldt).format("YYYY-MM-DD") || ''

        this.sitem = tmp

        if (!T.isEmpty(this.sitem.isttoutplac)) {
          // [관할기관] 코드에 해당하는 값이 없으면 [직접입력]으로 보임
          let check_inc = this.code.BG0000.filter(e => e.text == this.sitem.isttoutplac)

          if (check_inc.length == 0) { // isttoutplac의 값이 [관할기관] 코드에 일치 하는 것이 없다
            // 미사용이거나 한 번도 수정하지 않은 경우 etc로 지정하여 select box에서 기타가 선택되게 함
            if (this.sitem.isttoutplac__change < 1){
              this.sitem.isttoutplac_etc = this.sitem.isttoutplac
              this.sitem.isttoutplac = 'etc'
            }
          }
        }

        if (!T.isEmpty(this.sitem.clientclsf)) {
          // [위임인 구분] 코드에 해당하는 값이 없으면 [직접입력]으로 보임
          let check_client = this.code.B50000.filter(e => e.text == this.sitem.clientclsf)

          if (check_client.length == 0) { // clientclsf의 값이 [위임인 구분] 코드에 일치 하는 것이 없다
            //if (this.sitem.statclsf != 'BC0200') { // 사용하지 않은 증표는 clientclsf 값을 etc로 지정하여, select-box 에서 '직접입력'이 선택되게 한다.
            if (this.canRedEdit) {
              this.sitem.clientclsf_etc = this.sitem.clientclsf
              this.sitem.clientclsf = 'etc'
            }
          }
        }
        this.dbitem = _.cloneDeep(tmp) // 디비에서 조회한 값

        // ------------------------------------------------------------------------------------
        // 2. 증표상태가 신청중(CH_REQ)인 경우에는 신청정보 상세 조회
        // ------------------------------------------------------------------------------------
        if (this.sitem.statclsf == 'CH_REQ') {
          ui.httpGetDetail('/proc/N_VIAINFO_DTL_STAT', {
            viaregdt : this.sitem.viaregdt,
            viaseq   : this.sitem.viaseq,
          }, ret => {
            this.sitem.viastatmembset = _.get(ret, "data.rs1[0].viastatmembset", '') // 신청인
            this.sitem.viastatclsfnm  = _.get(ret, "data.rs1[0].viastatclsfnm", '')  // 신청구분명
          })
        }

        // ------------------------------------------------------------------------------------
        // 3. 조회된 결과로 담당변호사 목록 조회 (주의: 이걸 따로 빼면 정상적으로 작동되지 않는다)
        // ------------------------------------------------------------------------------------
        ui.httpGetDetail('/proc/N_VIAMEMB_SEL_LIST_EMP', {
          iv_pgsize   : 10000,
          iv_page     : 1,
          iv_viaregdt : viaregdt,
          iv_viaseq   : viaseq,
        }, ret => {
          let tmpList = ret.data.rs1

          // 사임/취하일자 문자열 포멧
          tmpList.forEach(e => {
            e.dbcancelclsf = e.cancelclsf // db 값 별도 저장 ( 이미 디비에 사임/취하가 있다면 보여주기만 하고 수정/불가 하게 하려고 )
            e.dbcanceldt   = e.canceldt   // db 값 별도 저장
            e.canceldt = e.canceldt && this.$moment(e.canceldt).format("YYYY-MM-DD")
            e.adddt    = e.adddt    && this.$moment(e.adddt)   .format("YYYY-MM-DD")
          })
          this.selectCustList = tmpList
          this.orgViaMembNos = tmpList.reduce((ret, item) => {ret.push((""+item.chrgmembno).trim()); return ret}, []) // 디비에 기록된 변호사 번호들

          this.sitem.lawyercnt = this.selectCustList.length

          // 증표 상태가 미사용(BC0100)이고 로그인 MEMBCLSF : P 이고 등록된 담당 변호사가 없을 경우 담당변호사에 로그인한 본인 추가
          if ( this.sitem.statclsf == 'BC0100'
            && this.$store.state.session.user.membclsf == 'P'
            && this.selectCustList.length == 0
          ) {
            // 사용자 정보 조회 후 담당변호사에 로그인한 본인 추가
            ui.httpGet('/proc/N_MEM_SEL_INFO_DTL', {},
            ret => {
              this.loginInfo = ret.data.rs1[0]
              this.selectCustList.push({...this.loginInfo });
            })
          }
        })

        this.submembersList = []
        // 분사무소 멤버 데이터가 있다면 # 으로 잘라서 리스트에 넣기
        if(!this.T.isEmpty(this.sitem.submembers)){
          this.sitem.submembers.split('#').forEach(e=> {
            this.submembersList.push(e)
          })
        }

      })
    },
    // -------------------------------------------------------------------------------------------------------------------
    // 담당 변호사 수정/삭제 가능 여부 --- N 전부불가, ALL 전부 가능,  ADD 추가만가능 (삭제 불가)
    // -------------------------------------------------------------------------------------------------------------------
    /*    담당변호사 추가 / 삭제 가능여부 ( 온라인 오프라인 동일하다 )

          사용시	                                                                 수정시
          -------------------------------------------------------------------     -------------------------------
    개인  "다른변호사 추가 / 삭제  가능                                           불가 ( read only 아무버튼 x)
          본인에 대해서는 자진삭제 불가 ( 본인에 대해서는 삭제 버튼 X )"

    소속	"같은소속 변호사 추가 / 삭제  가능                                      기존데이터는 삭제버튼 X, 추가만 가능 O
          본인에 대해서는 자진삭제 불가 ( 본인에 대해서는 삭제 버튼 X )"          본인에 대해서는 자진삭제 불가 ( 본인에 대해서는 삭제 버튼 X )"

    법인	같은소속 변호사 추가 / 삭제  가능	                                      기존데이터는 삭제버튼 X, 추가만 가능 O

    */
    showChargerAddBtn() { // 담당변호사 추가 버튼(회원추가) 보여줄까 ?
      const 사용시 = this.sitem.statclsf == 'BC0100' || this.sitem.statclsf == 'BC0500'
      //const 법률사무소정비 = this.sitem.membnm == '법률사무소 정비'
      const 사무실구분 = this.$store.state.session.user.officeclsf // P(개인), B(마스터, 소속변호사), C(마스터, 소속변호사), J(마스터, 소속변호사), D(마스터, 소속변호사)
      const 소속변경면제 = this.sitem.caseclsf == 'B10400' && this.sitem.freeclsf == 'B10910' // CASECLSF = B10400  면제 이고,  FREECLSF = B10910 소속변경인 경우.

      if (this.isOtherOffice) return false // 소속변경완료인 증표이면서 OFFICE가 불일치 : 회원추가 불가

      if (사용시 || 소속변경면제) { //|| 법률사무소정비
        return true
      } else { // 수정시 : 사용자의 OFFICECLSF가 B, C인 경우만 담당변호사 추가 가능
        /* 개인변호사 또는 개인스러운 변호사 ( 공동이나 조합은 개인변호사들이 한사무실을 같이 쓰는 개념이라 개인처럼 봐도 된다. ) 의 경우에는
         * 변호사가 추가될때 위임장을 새로 제출해야 하므로. 새로운 증표를 다시 등록해야 한다. 그게 연결사건인가??? 물어봐야지..
         *
         * 하지만 법인 및 법인유한(법인의 한 형태.. 결국 법인이랑 같음)의 경우에는 위임인이 그냥 그 법인에 위임한 것이므로
         * 별도로 위임장을 제출할 필요는 없지만, 담당변호사가 추가될때 법인출입을 위해서 담당변호사 추가신청서를 따로 제출한다.
         * 그래서 이 경우 담당변호사를 추가하고. 담당변호사 추가신청서에 기입하는 '추가신청일'을 입력하게 한다.
         *
         * (2020.12.24) 294번 요청 : 법인으로 소속변경한 경우에는 담당변호사 추가가 가능합니다만, 개인으로 소속변경한 경우에는 불가능하네요. 가능하게 해주세요.
         *                    조건 : CASECLSF = B10400  면제 이고,  FREECLSF = B10910 소속변경인 경우
         *                    결론 : 면제(소속변경)증표인 경우, 무조건 담당변호사 추가 버튼 보여줌.
         *                         : 조회되는 담당변호사 목록은 미사용 증표일 때 조회되는 것과 동일함.
         */
        switch(사무실구분) {
        case 'P': return false
        case 'B': return true
        case 'C': return true
        case 'J': return false
        case 'D': return false
        }
      }
      return false
    },
    showChargerDeleteBtn(item) { // 담당변호사 삭제 버튼
      const 사용시 = this.sitem.statclsf == 'BC0100'|| this.sitem.statclsf == 'BC0500'
      const 로그인구분 = this.$store.state.session.user.type // self / member / master
      const 내꺼여부 = this.$store.state.session.user.membno == item.chrgmembno && this.$store.state.session.user.membclsf == 'P'
      const 소속변경면제 = this.sitem.caseclsf == 'B10400' && this.sitem.freeclsf == 'B10910' // CASECLSF = B10400  면제 이고,  FREECLSF = B10910 소속변경인 경우.
      //const 법률사무소정비 = this.sitem.membnm == '법률사무소 정비'

      if (사용시 ) { //|| 법률사무소정비
        return 내꺼여부 ? false : true // 사용시에는 개인내꺼만 아니면 삭제버튼 가능
      } else { // 수정시

        // 294번 요청사항 : 면제(소속변경)증표인 경우, 무조건 담당변호사 추가 버튼이 보임.
        if (소속변경면제) return 내꺼여부 ? false : item.저장전 ? true : false // 나를 제외하고 저장 전 추가한 변호사는 삭제 가능

        switch(로그인구분) {
        case 'self': return false // 개인변호사는 수정시 삭제버튼 내꺼든 다른변호사든 무조건 불가 ( 이거 웬지 바뀔 듯 )
        case 'member': return 내꺼여부 ? false : item.저장전 ? true : false // 나를 제외하고 저장 전 추가한 변호사는 삭제 가능
        case 'master': return item.저장전 ? true : false // 저장 전 추가한 변호사는 삭제 가능
        }
      }
      return false
    },
    // -----------------------------------------------------------------------------------------------------------------
    // 담당변호사 팝업호출 / 선택 / 삭제
    // -----------------------------------------------------------------------------------------------------------------
    openCustPop() { // 담당변호사 팝업 호출
      //if (this.sitem.statclsf != 'BC0200') { //[사용(BC0200)]이 아닌 증표는 [수임일자] 기준으로 회원검색
        if (T.isEmpty(this.sitem.cntchargdt)) {
          return ui.alert("수임일자를 먼저 입력해 주세요.");
        }
        this.$refs.selectCust.open('B', this.sitem.search_membnm, this.sitem.selldt, this.sitem.cntchargdt, false)
     /* } else { // 기존 [사용(BC0200)]인 증표는 [현재시간] 기준으로 회원검색 this.$moment().format("YYYY-MM-DD")을 - > 수임일로 this.sitem.cntchargdt 변경 2022.07.14 최동현요청
        this.$refs.selectCust.open('B', this.sitem.search_membnm, this.sitem.selldt, this.$moment().format("YYYY-MM-DD"), this.sitem.onlineyn == 'N')
      }*/
    },
    selectCust(item) { // 담당변호사 추가 ( 클릭한 변호사를 담당변호사 목록에 추가 )
      if (this.selectCustList.filter(e => e.chrgmembno == item.chrgmembno).length > 0) {
        return ui.alert("이미 추가되어 있습니다.")
      }
      this.sitem.search_membnm = "" // 검색 이름 초기화
      item.cancelclsf = "B40100"    // 추가시 사임/취하구분 기본 : 공란
      item.membseq = this.selectCustList.length + 1
      item.저장전 = true
      console.log("this.sitem.statclsf = " + this.sitem.statclsf);

      if (this.sitem.statclsf == 'BC0200') { // 사용한 증표에서 추가하는 경우
        item.addyn = 'Y'
        item.adddt = this.$moment().format("YYYY-MM-DD")
        console.log("item.adddt = " + item.adddt);

      }
      this.selectCustList.push(item)
    },
    delCust(item) { // 담당변호사 제거 ( 목록에서 제거 )
      this.selectCustList = this.selectCustList.filter(e => e.membseq != item.membseq)
    },
    casenmYN() { // 사건명 - 미정 체크 여부 신동호2
      if (this.sitem.casenmyn == 'Y') {
        this.sitem.casenm = ''
        this.casenmDisable = true
      } else {
        this.casenmDisable = false
      }
    },
    casenoYN() { // 사건번호 - 미정 체크 여부
      if (this.sitem.casenoyn == 'Y') {
        this.sitem.caseno = ''
        this.casenoDisable = true
      } else {
        this.casenoDisable = false
      }
    },
    othersideYN() { // 상대방 - 없음 체크 여부
      if (this.sitem.othersideyn == 'Y') {
        this.sitem.otherside = ''
        this.othersideDisable = true
      } else {
        this.othersideDisable = false
      }
    },
    // -----------------------------------------------------------------------------------------------------------------
    // 저장
    // -----------------------------------------------------------------------------------------------------------------
    // 내용저장 호출 ( 유효성 체크 후 이상 없으면 itemUpdate 호출 )
    saveItem({flag}) {
      // prtnoUpdate - true : 발급번호 생성 , false : 발급번호 미생성 == 미리보기

      isDebug && console.log("saveItem("+ JSON.stringify(arguments[0])+")")

      // 법인계정은 법인 변호사 최소 1명 포함 필수
      if (flag != 'save_lost') {
        if (!_.isEmpty(this.error_viacanceldt)) {
          return ui.alert("전체 사임일을 확인해 주세요.")
        }

        if (this.$store.state.session.user.type == 'master') {
          // if (this.selectCustList.filter(e => e.blngmembno == this.$store.state.session.user.membno.trim()).length < 1) {
          if (this.selectCustList.length < 1 && this.submembersList.length < 1 ) { // 무조건 1인으로 변경요청하심 -> 담당변호사 없이 분사무소 변호사만 있어도 되는 것으로 요청 들어옴(265번).
            return ui.alert("법인 구성원 변호사 중 최소 1인은 담당변호사에 포함되어야 합니다.")
          }
        } else {
          // 마스터 계정이 아닌 경우
          if (this.selectCustList.length == 0) {
            return ui.alert("변호사를 선택해 주세요.")
          }
        }

        if (this.sitem.isttoutplac == 'etc') {
          if (T.isEmpty(this.sitem.isttoutplac_etc)) {
            return ui.alert("관할기관을 입력해 주세요.")
          }
        }

        if (this.sitem.clientclsf == 'etc') {
          if (T.isEmpty(this.sitem.clientclsf_etc)) {
            return ui.alert("위임인 구분을 입력해 주세요.")
          }
        }

        // 심급 기타를 선택한 경우
        // B11204 = 형사이외심급 / 기타
        // B11109 = 형시 / 기타
        if (this.sitem.simgeup == 'B11109' || this.sitem.simgeup == 'B11204') {
          if (T.isEmpty(this.sitem.simgeup_etc)) {
            return ui.alert("심급을 입력해 주세요.")
          }
        }

        if (this.sitem.casenmyn == 'Y') { // [사건명] 미정 체크함 신동호3
          this.sitem.casenm = '-'
        }

        if (this.sitem.casenoyn == 'Y') { // [사건번호] 미정 체크함
          this.sitem.caseno = '-'
        }

        if (this.sitem.othersideyn == 'Y') { // [상대방] 없음 체크함
          this.sitem.otherside = '-'
        }

        for(const item of this.selectCustList) {
          if (item.addyn == 'Y' && T.isEmpty(item.adddt))
            return ui.alert("담당변호사 추가지정일을 입력하셔야 합니다.")
        }
      }

      if (flag == 'save_use') { // 오프라인 증표 저장+닫기
        ui.confirm(
          ` <span style="color:red; font-size:17px;"> 종이증표는 경유확인서 인쇄가 불가하며, 저장 후에는 수임일자, 사건유형, 관할기관, 심급, 사건명, 위임인, 상대방 항목 수정이 불가하니 다시 한 번 확인하시기 바랍니다.
           <br/> 저장하시겠습니까? </span> `
          , "저장확인"
        ).then(r=> {
            if (!r) return
            this.sitem.viadt = this.$moment().format("YYYY-MM-DD")
            this.itemUpdate({flag})
          })
      } else if (flag == 'tmpsave_preview') { // 임시저장 + 인쇄 미리보기
        ui.confirm(
          ` <p style="font-size:17px;"> 사건 수임이 미정일 경우 <수정하기> 버튼을 클릭하시어 경유확인서를 인쇄하지 마시고, 실제 위임장을 제출하는 당일에 인쇄하시기 바랍니다.
            <span style="font-weight: bold; text-decoration: underline;"><br/>인쇄한 경유증표는 환불 또는 미사용으로 전환이 불가</span>합니다.
            <span style="color:red; font-weight: bold;"><br/>실제 위임장을 제출하는 당일에 인쇄하시기를 당부드립니다. </span> </p>`
          , "필독 사항 안내"
        ).then(r=> {
            if (!r) return
            this.itemUpdate({flag})
          })
      } else {
        this.itemUpdate({flag})
      }

      /*
      if (prtnoUpdate == true) {
        // 발급번호 생성인경우 이미 경고 confirm 에서 확인클릭해서 넘어온 경우라서 바로 저장함.
        this.itemUpdate({flag, prtnoUpdate})
      } else {
        // ui.confirm('저장하시겠습니까 ?', "저장 확인")
        //   .then(r => r && this.itemUpdate({flag, prtnoUpdate}))
          this.itemUpdate({flag, prtnoUpdate})
      }*/

    },
    // 내용저장 서버 API 호출
    itemUpdate({flag, prtnoUpdate}) {

      isDebug && console.log("itemUpdate("+ JSON.stringify(arguments[0])+")")

      // 1. 선택한 변호사 : 선택된 회원이 2명이상일 경우 (김xx#이xx 이런식으로 # 구분자를 붙임)
      this.selectCustList.forEach((item, i) => {
        this.sitem.viamembseq   = ((i == 0) ? '' : this.sitem.viamembseq   + '#') + (i+1)
        this.sitem.viamembnm    = ((i == 0) ? '' : this.sitem.viamembnm    + '#') + item.membnm
        this.sitem.viamembno    = ((i == 0) ? '' : this.sitem.viamembno    + '#') + item.membno
        this.sitem.viamembclsf  = ((i == 0) ? '' : this.sitem.viamembclsf  + '#') + item.membclsf
        this.sitem.chrgmembno   = ((i == 0) ? '' : this.sitem.chrgmembno   + '#') + item.chrgmembno
        this.sitem.chrgmembnm   = ((i == 0) ? '' : this.sitem.chrgmembnm   + '#') + item.chrgmembnm
        this.sitem.blngmembclsf = ((i == 0) ? '' : this.sitem.blngmembclsf + '#') + item.blngmembclsf
        this.sitem.blngmembno   = ((i == 0) ? '' : this.sitem.blngmembno   + '#') + item.blngmembno
        this.sitem.blngmembnm   = ((i == 0) ? '' : this.sitem.blngmembnm   + '#') + item.blngmembnm
        this.sitem.cancelclsf   = ((i == 0) ? '' : this.sitem.cancelclsf   + '#') + (item.cancelclsf || 'B40100') // 사임/취하 값을 [공란]으로
        this.sitem.canceldt     = ((i == 0) ? '' : this.sitem.canceldt     + '#') + (item.canceldt && this.$moment(item.canceldt).format("YYYYMMDD") || '')
        this.sitem.addyn        = ((i == 0) ? '' : this.sitem.addyn        + '#') + (item.addyn || '')
        this.sitem.adddt        = ((i == 0) ? '' : this.sitem.adddt        + '#') + (item.adddt && this.$moment(item.adddt).format("YYYYMMDD") || '')
      })


      if (T.isNullOrUndefined(this.submembersList) || this.submembersList.length < 1) {
        this.sitem.submembers   = ''
      }

      // 분사무소 추가 시 #을 구분자로
      this.submembersList.forEach((item, i) => {
        this.sitem.submembers = ((i == 0) ? '' : this.sitem.submembers + '#' ) + item
      })

      // 발급번호 업데이트 시 사용일 : 오늘
      if ((flag == 'update_prtno' || prtnoUpdate) && T.isEmpty(this.sitem.viadt)) {
         this.sitem.viadt = this.$moment().format("YYYYMMDD")
      }

      // 관할기관 [직접입력] 선택 시 : 입력 받은 값을 isttoutplac로 설정
      if (this.sitem.isttoutplac == 'etc') {
        this.sitem.isttoutplac = this.sitem.isttoutplac_etc
      }

      // 위임인 구분 [직접입력] 선택 시 : 입력 받은 값을 clientclsf로 설정
      if (this.sitem.clientclsf == 'etc') {
        this.sitem.clientclsf = this.sitem.clientclsf_etc
      }

      T.attrEmptyNumberToNull(this.sitem, ['pay_succ', 'pay_con']) // 숫자 파라미티에 '' 이면 오류나서 null로 변경

      // 분실 사용 처리일 경우 N_VIAINFO_UPD_DTL_EMP_LOST, 아니면 N_VIAINFO_UPD_DTL_EMP
      ui.httpPost(flag == "save_lost" ? "/proc_iv/N_VIAINFO_UPD_DTL_EMP_LOST" : "/proc_iv/N_VIAINFO_UPD_DTL_EMP_V02",
        {
          ...this.sitem,
          simgeup       : this.sitem.simgeup       || '', // TODO CHECK 심금에 대해서 전반적인 체크 필요. 일단 오류나서 넣기는 한다..
          viacanceldt   : this.sitem.viacanceldt && this.$moment(this.sitem.viacanceldt).format("YYYYMMDD") || '',
          accflag       : 'U', // 사용 수정
          lawyercnt     : this.selectCustList.length,
          menu          : this.menu,
        },
        ret => {
          const {msg, status, sellregdt, sellseq} = ret.data.rs1[0];

          console.log("업데이트 완료 :", ret.data.rs1[0]);

          if (status == '0') { // 작업이 정상 완료일때 완료페이지로 이동

            if (flag == 'tmpsave' || flag == 'tmpsave_preview') {
              ui.notify("임시저장 되었습니다.", {group: 'top_left', type: 'success'})
            } else {
              ui.notify(msg, {group: 'top_left', type: 'success'})
            }


            // return this.doPrintReport({showPRTNO: false}) // 저장 완료시 무조건 레포트 실행
            // console.log("flag 1 == ", flag);
            // [인쇄하기]인 경우 발급번호 업데이트 여부에 따라 PY/PN 으로 세팅

            if (flag == 'update_prtno') {
              this.isUseVia = true // 증표사용 플래그 ( 이렇게 하면 closed() 호출시 부모에게 증표가 사용되었음을 알린다. )
              // return this.doUpdatePrtno() // 저장 + 인쇄 ( 발급 )
              return this.doPrintReport({showPRTNO: true, isSetUseYn: true}) // 저장 + 인쇄 ( 발급 )
            }

            if (flag == 'save' || flag == 'tmpsave') {  // 저장
              this.reloadData(); // reload
              this.emitSave();
              return
            }

            if (flag == 'save_close') {  // 저장 + 닫기
              this.emitSave();
              return this.doClose();
            }

            if (flag == 'save_use') {  // 종이증표 저장 ( 및 사용 )
              this.isUseVia = true // 증표사용 플래그 ( 이렇게 하면 closed() 호출시 부모에게 증표가 사용되었음을 알린다. )
              this.emitSave();
              // return this.doClose();
              return
            }

            if (flag == 'save_lost') {  // 분실 사용 처리
              this.isUseVia = true // 증표사용 플래그 ( 이렇게 하면 closed() 호출시 부모에게 증표가 사용되었음을 알린다. )
              this.emitSave();
              return this.doClose();
            }

            if (flag == 'tmpsave_preview') { // 임시저장 + 미리보기
                this.reloadData(); // reload
                this.emitSave(); // emit
                return this.doPrintReport({showPRTNO: false})
            }

            if (flag == 'save_print') { // 저장 + 인쇄
                this.reloadData(); // reload
                this.emitSave(); // emit
                return this.doPrintReport({showPRTNO: true})
            }

            // flag = prtnoUpdate ? (prtnoUpdate == true ? 'PY' : 'PN') : flag
            // console.log("flag 2 == ", flag);

            // switch(flag) {
            //   case 'save_close': this.emitSave(); return this.doClose();                        // 저장 + 닫기
            //   case 'save_preview':
            //     this.reloadData(); // reload
            //     this.emitSave(); // emit
            //     return this.doPrintReport({showPRTNO: false}) // 저장 + 미리보기

              // case 'S'  : this.emitSave(); return this.doClose();       // 저장
              // case 'PY' : return this.doUpdatePrtno(); // (저장 + 인쇄) 발급번호 업데이트 후 레포트 실행
              // case 'PN' : return this.doPrintReport({showPRTNO: true})  // (저장 + 인쇄) 레포트 실행
              // case 'save': this.loadData(this.sitem); return this.doPrintReport({showPRTNO: false}) // 그냥 저장
            // }
          }  else {
            ui.alert(msg, '오류', {type: 'error'})
          }
        })
    },
    closed() { // 모달을 닫을때 증표를 사용한 경우 증표수정 메뉴로 이동한다.
      if (this.isUseVia) {
        this.emitViaUseOk(this.sitem) // 증표를 사용함! ( 부모에서 router.push 해야함)
      }
    },
    emitSave() {
      // this.$emit("save")
      this.cb_save && this.cb_save()
    },
    emitViaUseOk(item) { // 증표를 사용함! ( 부모에서 router.push 해야함)
      this.cb_via_use_ok && this.cb_via_use_ok(item)
      // this.$emit("via_use_ok", item) // 증표를 사용함! ( 부모에서 router.push 해야함)
    },

    // -----------------------------------------------------------------------------------------------------------------
    // 인쇄
    // -----------------------------------------------------------------------------------------------------------------
    // 인쇄 호출
    doPrintCall() {

      isDebug && console.log("doPrintCall("+ JSON.stringify(arguments[0])+")")

      // 미리보기가 아닌경우. 발급번호 없을때 컴펌 ( 있으면 패쓰 )

      // [인쇄하기] = (저장+인쇄)
      // 발급번호가 없을 경우 메세지 출력 및 발급번호 업데이트
      if (T.isEmpty(this.sitem.prtno)) {

        ui.confirm(
          `<div style="font-size: 20px;">인쇄 후에는 수임일자, 사건유형, 관할기관, 심급, 사건명, 위임인, 상대방 항목
          <font color=red>수정이 불가</font>하니 다시 한번 확인 부탁드립니다.
          또한 출력한 증표는 환불이 불가하니 이 점 유의하시기 바랍니다.
          경유확인서를 인쇄하시겠습니까?
`
          , "유의사항", {width: 750}
        ).then( r=>r && this.saveItem({flag: 'update_prtno'}) )

        // 발급번호가 있으면 저장 후 레포트 실행
      } else {
        this.saveItem({flag: 'save_print'})
      }

    },
    // // 발급번호 생성 ( 성공시 레포트 출력 )
    // doUpdatePrtno() {
    //   ui.httpPostDetail("/proc_iv/N_VIAINFO_UPD_DTL_EMP_PRINT",
    //     {
    //       ..._.pick(this.sitem, ['viaregdt', 'viaseq', 'viadt']),
    //       caseclsfnm : T.left(this.sitem.caseclsfnm, 2)
    //     }, ret => {
    //       const {msg, status} = ret.data.rs1[0]
    //       if (status == '0') { // 작업이 정상 완료일때
    //         // this.sitem.prtno = prtno
    //         // this.sitem.prtdt = prtdt
    //         this.reloadData() // reload
    //         this.emitSave();
    //         this.doPrintReport({showPRTNO: true})
    //       } else {
    //         ui.alert(msg) // 오류
    //       }
    //     }
    //   )
    // },
    /**
     * isSetUseYn : Boolean - 사용셋팅 여부 USE_MEMBNO, USE_MEMBCLSF 등을 셋팅한다.
     */
    doUpdatePrtAdd(isSetUseYn, okCallBackFunc) {
      ui.httpPostDetail("/proc_iv/N_VIAINFO_UPD_DTL_EMP_PRINT_ADD_V01",
        {
          ..._.pick(this.sitem, ['viaregdt', 'viaseq', 'viadt']),
          caseclsfnm : T.left(this.sitem.caseclsfnm, 2),
          useyn: isSetUseYn ? 'Y' : 'N'
        }, ret => {
          const {msg, status} = ret.data.rs1[0]
          if (status == '0') { // 작업이 정상 완료일때
            // this.sitem.prtno = prtno
            this.reloadData() // reload
            okCallBackFunc() // 콜백함수 실행
          } else {
            ui.alert(msg) // 오류
          }
        }
      )
    },
    // 레포트 모드로 전환 ( 수정폼 가리고 클립리포트 보여주기 )
    doPrintReport({showPRTNO, isSetUseYn = false}) {

      isDebug && console.log("doPrintReport("+ JSON.stringify(arguments[0])+")")

      if (showPRTNO) {

        // 첫인쇄시
        if (this.prtCnt < 1) {
          // 발급번호가 없으면 발급번호,인쇄일 업데이트 후 인쇄화면 호출
          // if (this.T.isEmpty(this.sitem.prtno)) { //////// TODO CHECK 이거 뭔가 불안하다... 무슨 의도였을까 ??
            return this.doUpdatePrtAdd(isSetUseYn, () => this.doPrintReport_real({showPRTNO}))
          // } else {
            // 발급번호가 있으면 아마도 첫 사용시라서 이미 컴펌한 상태라 바로 인쇄한다.
            // return this.doPrintReport_real({showPRTNO})
          // }
        }

        if (this.prtCnt > 2) return ui.alert("3회 모두 인쇄하셨습니다.\n\n더이상 인쇄할 수 없습니다.", "인쇄불가", { color: "red"})

        if (Adobe.checkPrintAble() == false) {
          // this.alert(msg, title || '오류', {type: 'error'})
// `인터넷익스플로러 브라우저로 인쇄할 경우
// PDF Reader 프로그램이 설치되지 않았거나 버젼이 낮을 경우(10 이하) 인쇄가 제대로 이루어지지 않을 수 있습니다.
// 만약 인쇄 절차가 진행되지 않을 경우 Chrom 브라우저를 이용하시거나 PDF Reader의 버젼을 최신으로 업데이트하시기 바랍니다.
// PDF Reader 다운로드 : <a href="https://get.adobe.com/reader/?loc=kr" target="_blank">https://get.adobe.com/reader/?loc=kr</a>
// 크롬 다운로드       : <a href="https://www.google.com/intl/ko/chrome/" target="_blank">https://www.google.com/intl/ko/chrome/</a>`
          return ui.alert(
`인터넷익스플로러를 사용중이시면서 PDF Reader 프로그램이 설치되지 않았거나 버젼이 낮은 경우(10 이하)라서 인쇄가 불가능합니다.

아래 링크를 클릭하여 PDF Reader 를 최신버전으로 설치하시거나 크롬 웹 브라우져를 이용하여 다시 인쇄를 시도해 주세요.

- 아래 -
PDF Reader 다운로드 : <a href="https://get.adobe.com/reader/?loc=kr" target="_blank">https://get.adobe.com/reader/?loc=kr</a>
크롬 다운로드       : <a href="https://www.google.com/intl/ko/chrome/" target="_blank">https://www.google.com/intl/ko/chrome/</a>`
          , "인쇄 불가 안내", {type: 'error', width: 540})
        }

        ui.confirm(`현재 ${ this.prtCnt }회 인쇄하셨습니다.( 최대 3회. 현재 ${ 3 - this.prtCnt }회 남음)\n정말로 인쇄하시겠습니까 ?`, "인쇄확인", { color: "blue"})
          .then(r=> {
            if (!r) return ui.notify("인쇄 작업이 취소되었습니다.", {group: 'top_left', type: 'info'})
            // 디비 3회 체크 밑 업데이트 하고 인쇄
            this.doUpdatePrtAdd(isSetUseYn, () => this.doPrintReport_real({showPRTNO}))
          })

      } else {
        this.doPrintReport_real({showPRTNO})
      }
    },
    // 레포트 실제로 인쇄
    doPrintReport_real({showPRTNO}) {

     // alert('print1')

      console.log("doPrintReport_real() : showPRTNO = ", showPRTNO);

      // this.print_mode = true // 레포트 모드 ( 인쇄모드 ) 로 전환 --> 폼을 가린다.
      // if (!showPRTNO) { // 미리보기 일때만 레포트 모드로 화면을 전환한다.
        this.print_mode = true // 레포트 모드 ( 인쇄모드 ) 로 전환 --> 폼을 가린다.
      // }
      // 레포트 호출

      const url = "/ClipReport4/print_via.jsp?" + T.makeUrlQueryString({
          printyn     : showPRTNO ? 'Y' : 'N', // Y 인쇄 (발급번호 표시),  N 미리보기 ( 발급번호에 미리보기라고 표시 )
          viaregdt    : this.sitem.viaregdt,
          viaseq      : this.sitem.viaseq,
          login_pers  : this.$store.state.session.user.no,
          r           : Math.random(), // 캐쉬 방지
        })

      // if (showPRTNO == false) { // 인쇄 미리보기

      //   window.open(url, "_blank", "width = 1214, height = 1446, top = 100, left = 200, location = no")

      // } else {

//alert('print2')
        this.report = url
//alert('print3')
      // }
    },

    // -----------------------------------------------------------------------------------------------------------------
    // 기타 ( UI )
    // -----------------------------------------------------------------------------------------------------------------
    onClickCancelCslf(e, item, key, unClickValue) { // 사임/취하 radio box 체크한거 또 체크시 체크해제
      const newValue = e.target.value
      const oldValue = item[key]
      let isSet = false

      if (newValue == oldValue) {
        item[key] = unClickValue
        e.target.checked = false
      } else {
        item[key] = newValue
        isSet = true
      }

      // newValue : B40200 사임 B40300 취하 B40100 공란
      if (isSet == true && key == 'cancelclsf' && newValue != 'B40100') { // 담당변호사 사임 선택시
        this.setLastCancelDT()
      }

      this.checkViacanceldt() // 전체 사임일 체크 // 이거 없애면 안된다. 중복실행 괜찮다.

    },
    setLastCancelDT() { // 담당변호사 개별로 사임일 입력시
      if (this.selectCustList.every(item => item.cancelclsf == "B40200")) { // 모든 변호사가 사임한 경우
        const maxDT = this.getMaxCancelDT() // 변호사들중 가장 마지막 사임일
        // alert (maxDT.canceldt)
        this.sitem.viacancelclsf = 'B40200'
        this.sitem.viacanceldt   = maxDT
      }
      this.checkViacanceldt() // 전체사임일 유효성 체크
    },
    onChange_isttoutplac($event) {
      if ($event.target.value == 'etc') {
        this.$nextTick(()=> this.$refs.isttoutplac_etc.focus() )
      }
    },
    doLost() {
      ui.confirm(
        `<div class="b ft17">종이증표 미입력분 사용 처리란?<br/>
<b class="red01 underline">종이증표를 분실하였거나 시간이 오래지나 사건내용을 알 수 없을 경우에 종이증표를 분실처리하는 기능입니다.

종이증표 사건내용을 입력하실 경우에는 이 메뉴가 아니라 이전 화면으로 이동해서 사건내용 입력 후 저장하기 버튼을 누르시기 바랍니다.
</b></div>
*유의사항
(1)미입력분 사용 처리한 증표는 미사용으로 다시 전환할 수 없습니다.
(2)미입력분 사용 처리한 증표는 [수임사건 내역 조회] > [수임사건 건수 조회] 및 [수임사건 상세 조회]에서 제외됩니다.

<B>사용처리 하시겠습니까?<b/>`, "확인" , {width: 550}
        ).then(r=>r && this.saveItem({flag:'save_lost'}))
    },
    onChange_cntchargdt(v) {
      if (v && this.$moment().format("YYYY-MM-DD") < v) {
        ui.alert("수임일자는 오늘 이후의 날짜를 선택할 수 없습니다.");
        this.sitem.cntchargdt = ''
      } else {
        this.sitem.cntchargdt = v
      }

      // ui.httpPost("/use/membs_check", {
      //   cntchargdt : this.sitem.cntchargdt,
      //   membs: this.selectCustList,
      // }, ret => {
      //   console.log(ret.data);
      // })
    },
    popupViainfo(item) { // 증표팝업
      if (!item || !item.rcptno) return
      if (!item.client) return
      const rcptno1 = item.rcptno.substring(0, 5)
      const rcptno2 = item.rcptno.substring(5, 11)
      const client  = item.client

      const url = `/front/viainfo/detail?rcptno1=${ rcptno1  }&rcptno2=${ rcptno2 }&membno=&client=${ client }&noalert=1`
      window.open(url, "_blank", "width = 1214, height = 1446, top = 100, left = 200, location = no")
    },
    getMaxCancelDT() { // 변호사들중 가장 마지막 사임일
      const maxDTitem = _.maxBy(this.selectCustList, i=>i.canceldt) // 가장 큰 사임일
      const maxDT = maxDTitem && maxDTitem.canceldt || ''
      return maxDT
    },
    checkViacanceldt() { //전체 사임취하일 입력시 또는 담당변호사 개별로 날짜 선택시
      if (_.isEmpty(this.sitem.viacanceldt) || _.isEmpty(this.sitem.viacancelclsf)) {
        this.error_viacanceldt = ""
        return // 미입력이면 패쓰
      }
      const maxDT = this.getMaxCancelDT() // 변호사들중 가장 마지막 사임일
      if (_.isEmpty(maxDT)) { this.error_viacanceldt = ""
        return // 가장큰거 없으면 패쓰
      }

      console.log("가장  사임일 : ", this.sitem.viacanceldt )
      console.log("전체 큰 사임일 : ", maxDT )

      if (this.sitem.viacanceldt.replace(/-/g, '') < maxDT.replace(/-/g, '')) {
        this.error_viacanceldt = "오류! 변호사들중 가장 마지막 사임일보다 작습니다."
      } else {
        this.error_viacanceldt = ""
      }

    },
    addsubmembers(item){

      if(this.T.isEmpty(item)){
        return ui.alert("분사무소 담당변호사 이름을 입력해주세요.")
      }

      if(this.T.contains(item, '#')){
        return ui.alert("분사무소 담당변호사 이름은 한글로 입력해주세요.")
      }

      this.submembersList.push(item)
      console.log("submembersList : "+ this.submembersList);

      this.sitem.submemb = ''

    },
    delSubmem(item){
      this.submembersList = this.submembersList.filter(e => e != item)

    }
  }
}
</script>

<style>
.v--modal-box.v--modal { position: absolute; top:10px !important;}
.v--modal-box.v--modal:active { top:auto;}
 </style>

<style scoped>
#id_rel { text-decoration: underline; }
#id_rel:hover .toggleInfo, #id_client:hover .toggleInfo, #id_paper:hover .toggleInfo { display: inline-block }

#id_chcase_Y .toggleInfo { margin-top:30px; margin-left:-200px; width:320px; height:200px;}
#id_chcase_Y:hover .toggleInfo, #id_paper:hover .toggleInfo { display: inline-block }

#id_paper { margin:-28px 0 0 2px; position: absolute;}
#id_paper .toggleInfo { margin-top:-210px; margin-left:-480px; width:480px; }

.btn.center { margin: 0px 0 0 10px;}
.btn.mini { padding: 0px; background-color: white; margin: -3px 0 0 7px;}
/* .tbl01 tr th.gubun, .tbl01 th:first-child { width:120px} */
.tbl01 tr th.cont { width:280px !important;}
.expcomment ol li,  .expcomment p { line-height:1.4; }
.expcomment ol li { margin-bottom:2px;}
.comment_gray p.tit { margin-top:15px;}
.input_name { width:120px}

.tbl01.view01 .list01 th:first-child { width:60px;;}
@media screen and (max-width:640px){
  .damdang_wrap  { width:calc(100% + 140px); margin:5px 0 -10px -137px}
  #id_client:hover .toggleInfo { display: auto;}
  #id_paper:hover .toggleInfo { display: inline-block; margin-left:-200px;; width:320px !important; }


  .input_name { width:100px}

  .th_lawer { height:30px;  border:none; background: #fff;}
  .td_lawer { border:none;}
  .btn.center { margin: 0 0 0 3px; }
}

</style>